import { Box, Typography } from "@mui/material";
import { format } from "date-fns";

export const getGlJournalEntryColumns = () => [
  {
    accessorKey: "reference",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Reference</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500} fontFamily="monospace">
        {row.original.reference ?? "N/A"}
      </Typography>
    ),
  },

  {
    accessorKey: "eventId",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Event ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontFamily="monospace">
        {row.original.eventId ?? "N/A"}
      </Typography>
    ),
  },

  {
    accessorKey: "eventType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Event Type</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.eventType ?? "N/A"}
      </Typography>
    ),
  },

  {
    accessorKey: "valueDate",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Value Date</div>,
    cell: ({ row }) => {
      const date = row.original.valueDate;
      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {format(new Date(date), "MMM d, yyyy")}
        </div>
      );
    },
  },

  {
    accessorKey: "postedAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Posted At</div>,
    cell: ({ row }) => {
      const date = row.original.postedAt;
      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {format(new Date(date), "MMM d, yyyy · HH:mm")}
        </div>
      );
    },
  },

  {
    accessorKey: "narration",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Narration</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", maxWidth: 260 }}>
        {row.original.narration ?? "N/A"}
      </div>
    ),
  },

  {
    accessorKey: "totalAmount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Total Amount</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.totalAmount != null
          ? Number(row.original.totalAmount).toLocaleString()
          : "—"}
      </Typography>
    ),
  },

  {
    accessorKey: "currency",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Currency</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.currency ?? "N/A"}
      </Typography>
    ),
  },

  {
    accessorKey: "status",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const status = row.original.status;

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            fontSize: "0.75rem",
            fontWeight: 500,
            backgroundColor:
              status === "POSTED"
                ? "#ecfdf5"
                : status === "DRAFT"
                  ? "#f3f4f6"
                  : "#fef2f2",
            color:
              status === "POSTED"
                ? "#065f46"
                : status === "DRAFT"
                  ? "#374151"
                  : "#991b1b",
            whiteSpace: "nowrap",
          }}
        >
          {status ?? "N/A"}
        </Box>
      );
    },
  },

  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created At</div>,
    cell: ({ row }) => {
      const date = row.original.createdAt;
      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {format(new Date(date), "MMM d, yyyy · HH:mm")}
        </div>
      );
    },
  },
];
